import React, { Component } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';
import Select, { components } from 'react-select';
import css from './FieldSelectModern.module.css';
import { injectIntl } from 'react-intl';
const CONTENT_MAX_LENGTH = 5000;
const { Option } = components;

class FieldSelectModernComponent extends Component {
  render() {
    /* eslint-disable no-unused-vars */
    const {
      rootClassName,
      className,
      inputRootClass,
      disabled,
      customErrorText,
      id,
      label,
      input,
      meta,
      onUnmount,
      isUncontrolled,
      inputRef,
      intl,
      options,
      subHeading,
      onFieldChange,
      custom = false,
      isCheckoutPage,
      ...rest
    } = this.props;
    if (label && !id) {
      throw new Error('id required when a label is given');
    }

    const { valid, invalid, touched, error } = meta;
    const isTextarea = input.type === 'textarea';
    const errorText = customErrorText || error;
    const style = isCheckoutPage?{
      multiValueLabel: (base,state) => ({
        ...base,
        // backgroundColor: 'red',
        // backgroundColor: '#9ca3af',
        color: 'white',
        fontWeight: 'bold',
        padding: '5px',
        // padding: '0rem 0.5rem',
      }),
      control: (base,state) => ({
        ...base,
        backgroundColor: 'rgb(255, 255, 255)',
        borderRadius:'0px',
        // border:"3px solid red",
        borderColor:state.isFocused ? '#80bdff':'transparent',
        boxShadow:state.isFocused ? '0 0 0 0.2rem rgb(0 123 255 / 25%)':'',
        transition:state.isFocused ?'all ease-in-out 100ms':'',
        height:'3rem',
        '&:hover': {
          borderColor: 'transparent', // Change border color on hover
        },
        
      }),
      menu: base => ({
        ...base,
        backgroundColor: 'white',
        overflowY: 'auto',
        height:'11rem'
      }),

    }:{
      multiValueLabel: (base,state) => ({
        ...base,
        // backgroundColor: 'red',
        backgroundColor: '#9ca3af',
        color: 'white',
        fontWeight: 'bold',
        padding: '0rem 0.5rem',
      }),
      control: (base,state) => ({
        ...base,
        backgroundColor: 'rgb(255, 255, 255)',
        borderRadius:'6px',
        borderColor:state.isFocused ? '#80bdff':'#d8dce6',
        boxShadow:state.isFocused ? '0 0 0 0.2rem rgb(0 123 255 / 25%)':'',
        transition:state.isFocused ?'all ease-in-out 100ms':'',
        // border:'1px solid red',
        height:'3rem',
        
      }),
      menu: base => ({
        ...base,
        backgroundColor: 'white',
        overflowY: 'auto',
        height:'11rem'
      }),
    };
    // Error message and input error styles are only shown if the
    // field has been touched and the validation has failed.
    const hasError = !!customErrorText || !!(touched && invalid && error);
    const fieldMeta = { touched: hasError, error: errorText };
    // Textarea doesn't need type.
    const { type, ...inputWithoutType } = input;
    // Uncontrolled input uses defaultValue instead of value.
    const { value: defaultValue, ...inputWithoutValue } = input;
    // Use inputRef if it is passed as prop.
    const refMaybe = inputRef ? { ref: inputRef } : {};
    const inputClasses =
      inputRootClass ||
      classNames(css.input, {
        [css.inputSuccess]: valid,
        [css.inputError]: hasError,
        [css.textarea]: isTextarea,
      });
    const maxLength = CONTENT_MAX_LENGTH;

    const inputProps = isTextarea
      ? {
          // className: inputClasses,
          id,
          rows: 1,
          maxLength,
          ...refMaybe,
          ...inputWithoutType,
          ...{ options: options },
          ...rest,
        }
      : isUncontrolled
      ? {
          // className: inputClasses,
          id,
          type,
          defaultValue,
          ...refMaybe,
          ...inputWithoutValue,
          ...{ options: options },
          ...rest,
        }
      : {
          className: inputClasses,
          id,
          type,
          ...refMaybe,
          ...input,
          ...{ options: options },
          ...rest,
        };
    const { onChange } = inputProps;
    const classes = classNames(rootClassName || css.root, className);
    return (
      <div className={classes} style={disabled ? { pointerEvents: 'none', opacity: '0.4' } : {}}>
        {label ? (
          <label htmlFor={id} className={css.label}>
            {label}
          </label>
        ) : null}
        <p className={css.subHeading}>{subHeading}</p>
        {/* <Select
          {...inputProps}
          // styles={style}
          onChange={e => {
            onChange(e);
            if (onFieldChange) {
              onFieldChange(e);
            }
          }}
        /> */}
        <Select
          {...inputProps}
          styles={style}
          onChange={e => {
            onChange(e);
            if (onFieldChange) {
              onFieldChange(e);
            }
          }}
          // components={customOptions}
          // {...{ options: optionsOutput }}
        />
        <ValidationError fieldMeta={fieldMeta} />
      </div>
    );
  }
}
class FieldSelectModern extends Component {
  componentWillUnmount() {
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  }
  render() {
    return <Field component={FieldSelectModernComponent} {...this.props} />;
  }
}
export default injectIntl(FieldSelectModern);
